// PrimaryButton.jsx
import React from "react";

const PrimaryButton = ({ as = "button", className = "", children, ...props }) => {
  const Component = as;
  return (
    <Component
      className={`bg-cta text-white px-5 py-2 rounded-xl font-semibold shadow hover:opacity-90 transition duration-200 ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default PrimaryButton;
